import { styled } from '@mui/material/styles';

import { Typography } from '../../atoms/Typography';

export const StyledMainHeaderTypography = styled(Typography)`
  margin-bottom: 10px;
`;

export const StyledDescriptionTypography = styled(Typography)`
  margin-bottom: 10px;
`;